import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from '../../globalStyles';
import {
  InfoSec,
  InfoRow,
  InfoColumn,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  ImgWrapper,
  Img
} from './InfoSection.elements';
import buffer from '../../images/maintain/buffer.png';
import control from '../../images/maintain/control.png';
import doorlock from '../../images/maintain/doorlock.png';
import guide from '../../images/maintain/guide.png';
import overspeed from '../../images/maintain/overspeed.png';
import bedplete from '../../images/maintain/bedplete.png';
import img3 from '../../images/img3.png';
import { BsDot } from 'react-icons/bs'
function Maintainance({
  primary,
  lightBg,
  topLine,
  lightTopLine,
  lightText,
  lightTextDesc,
  headline,
  description,
  buttonLabel,
  img,
  bglight,
  alt,
  imgStart,
  start,
  boxsh
}) {
  return (
    <>
      <InfoSec lightBg={true} boxsh={false}>
        <Container>
         <InfoRow imgStart={imgStart}>
          <InfoColumn>
              <ImgWrapper  >
                <Img src={img3} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Our maintenance plan ensures maximum service life plus maximum comfort for our customers.</Heading>
                 <TopLine  style={{ color:'#fff'}} lightTopLine={lightTopLine} bglight={  bglight}
>Product Highlights:</TopLine>
                <Subtitle lightTextDesc={true}>  <BsDot  style={{ fontSize:"15px" }} />We provide indoor & outdoor Escalators and Moving Walks. <br/> <BsDot  style={{ fontSize:"15px" }} />Safe and Reliable Solutions.<br/> <BsDot  style={{ fontSize:"15px" }} />Industry leading after sales service, maintenance plans are applied according the type of your building. <br/> <BsDot  style={{ fontSize:"15px" }} />Also, we provide inclined & horizontal products.'</Subtitle>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
          <InfoRow >
          <InfoColumn>
              <ImgWrapper start={start}>
                <Img src={control} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Control Unit</Heading>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
          <br />
                    <br/>

          <InfoRow  style={{ flexDirection:'row-reverse'}}>
          <InfoColumn>
          
              <ImgWrapper  start={start='false'}>
                <Img src={buffer} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Buffer</Heading>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
          <br/>
                    <br/>

          <InfoRow >
          <InfoColumn>
              <ImgWrapper  start={start}>
                <Img src={doorlock} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Door Lock</Heading>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
          <InfoRow style={{ flexDirection:'row-reverse'}}>
          <InfoColumn>
              <ImgWrapper start={start}>
                <Img src={overspeed} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Overspeed Governor</Heading>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
          <br />
                    <br/>

          <InfoRow  >
          <InfoColumn>
          
              <ImgWrapper  start={start='false'}>
                <Img src={bedplete} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Bedplate</Heading>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
          <br/>
                    <br/>

          <InfoRow style={{ flexDirection:'row-reverse'}}>
          <InfoColumn>
              <ImgWrapper  start={start}>
                <Img src={guide} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Guide Rails</Heading>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
        </Container>
      </InfoSec>
    </>
  );
}

export default Maintainance;
